<div [ngClass]="{'d-flex flex-row':!isMobileView}">
    <usar-top-bar [ngClass]="{'collapsed':isMobileView,'sidebar':!isMobileView}" [layout]="isMobileView?'collapsed':'sidebar'" ngSkipHydration > </usar-top-bar>
    <main>
        <!-- {{isMobileView?'collapsed':'sidebar'}} from {{innerWidth}} {{isMobileView}} -->
        <router-outlet></router-outlet>
    </main>
</div>